import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-stock-by-date',
  standalone: false,
  
  templateUrl: './inventory-stock-by-date.component.html',
  styles: ``
})
export class InventoryStockByDateComponent {

}
